import React from "react";
import { Bar } from "react-chartjs-2";
import numeral from "numeral";
import { pickHex } from "utils/ColorUtils";
import t from "utils/Lang";

type BarChartProps = {
  rawDataArray: Array<any>;
  keyAttribute: string;
  valueAttribute: string;
  fromColor?: Array<number>;
  toColor?: Array<number>;
};

const BarChart = ({
  keyAttribute,
  rawDataArray,
  valueAttribute,
  fromColor = [0, 204, 102],
  toColor = [0, 204, 102],
}: BarChartProps) => {
  const barChartOptions = {
    responsive: true,
    legend: {
      display: false,
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            callback: function (value: number) {
              return numeral(value).format("0.0a");
            },
            fontColor: "#1c3f7a",
            fontFamily: "Inter",
          },
          gridLines: {
            display: false,
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontColor: "#1c3f7a",
            fontFamily: "Inter",
          },
          gridLines: {
            display: false,
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem: any) {
          return numeral(tooltipItem.yLabel).format("0,0");
        },
      },
    },
    elements: {
      line: {
        fill: false,
        lineTension: 0,
      },
    },
  };

  const chartData = {
    labels: rawDataArray?.map((eachPoint) => eachPoint[keyAttribute]),
    datasets: [
      {
        type: "bar",
        fill: false,
        backgroundColor: rawDataArray?.map((_, idx) =>
          pickHex(fromColor, toColor, idx / rawDataArray.length)
        ),
        data: rawDataArray?.map((eachPoint) => eachPoint[valueAttribute]),
      },
    ],
    barChartOptions,
  };

  if (rawDataArray && rawDataArray.length <= 0) {
    return (
      <div className="bar-chart-container">
        <p className="bar-chart__empty-text">{t().map__no_data_yet}</p>
      </div>
    );
  }
  return (
    <div className="bar-chart-container">
      <Bar
        data={chartData}
        width={100}
        height={80}
        options={chartData.barChartOptions}
      />
    </div>
  );
};

export default BarChart;
